import { render, staticRenderFns } from "./MemberSelector.vue?vue&type=template&id=bcb41b78"
import script from "./MemberSelector.vue?vue&type=script&lang=ts"
export * from "./MemberSelector.vue?vue&type=script&lang=ts"
import style0 from "./MemberSelector.vue?vue&type=style&index=0&id=bcb41b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports